import {
  Box,
  Button,
  CircularProgress,
  useTheme,
} from "@material-ui/core";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { CollectionSelectModal } from "../../modals";
import { selectSelectedCollection } from "../../store/collection/collection.selector";
import { ExpandMore, ExpandLess } from "@material-ui/icons";

interface IProps {
  minWidth?: number;
}

const SearchBoxComponent: React.FC<IProps> = ({
  minWidth,
}) => {
  const theme = useTheme();
  const [collectionModal, setCollectionModal] = useState(false);
  const selectedCollection = useSelector(selectSelectedCollection);

  return (
    <Box display="flex" alignItems="center" minWidth={minWidth}>
      <CollectionSelectModal
        open={collectionModal}
        onClose={() => setCollectionModal(!collectionModal)}
      />
      <Button
        color="primary"
        size="large"
        variant="contained"
        disableElevation
        onClick={() => setCollectionModal(true)}
        style={{
          textTransform: "none",
          backgroundColor: theme.palette.primary.main,
        }}
        endIcon={!selectedCollection.loading ? (
            !collectionModal ? (
              <ExpandMore style={{ color: theme.palette.common.white }} />
            ) : (
              <ExpandLess style={{ color: theme.palette.common.white }} />
            )
          ) : undefined
        }
      >
        {selectedCollection.loading ? (
          <CircularProgress
            size={26}
            style={{ color: theme.palette.common.white }}
          />
        ) : (
          selectedCollection.data?.name??'Select collection'
        )}
      </Button>
    </Box>
  );
};

export default SearchBoxComponent;
